import { UIEngineRenderer } from "../../components/UIEngineRenderer";

export function CheckinPage() {
  return (
    <UIEngineRenderer
      workflowId="checkin.terminal.flow"
      onComplete={(sessionId) => {
        console.log("CheckIn completed successfully:", sessionId);
        // Optional: Navigate to success page or refresh
      }}
      onCancel={(sessionId) => {
        console.log("CheckIn cancelled:", sessionId);
        // Optional: Show cancellation message
      }}
      onError={(error) => {
        console.error("CheckIn error:", error);
        // Optional: Show error notification
      }}
    />
  );
}
